import { Component, ChangeDetectionStrategy, Input, TemplateRef, input } from '@angular/core';

type CustomStyles = {
  icon1FontSize: string;
  icon2FontSize: string;
};
@Component({
  selector: 'result-answer-ghost',
  templateUrl: './result-answer-ghost.component.html',
  styleUrls: ['./result-answer-ghost.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultAnswerGhostComponent {
  readonly progressMessage = {
    web_search: {
      message: 'Searching the web...',
      icon: 'icon-network',
    },
    file_search: {
      message: 'Reading documents...',
    },
  };
  @Input() avatarTemplate: TemplateRef<any>;
  @Input() customStyles: CustomStyles;
  @Input() showLoadingText: boolean;
  progressId = input<string>();
}
